import { Injectable } from '@angular/core';

import { Team } from '@app/models/team';
import { AuthService } from '@app/services/auth.service';
import { Firestore } from '@angular/fire/firestore';
import { collection, deleteDoc, doc, DocumentData, DocumentReference, getDocs, query, where } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(
    private firestore: Firestore,
    public auth: AuthService
  ) { }
  async getTeams(): Promise<Team[]> {
    const snapshot = await getDocs(collection(this.firestore, 'team'));
    const teams = snapshot.docs.map(docSnap => {
      const docData = docSnap.data() as Team;
      return { ...docData, id: docSnap.id };
    });

    teams.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      } else if (a.name === b.name) {
        return 0;
      }
    });

    return Promise.resolve(teams);
  }

  async getTeamRef(name: string): Promise<DocumentReference<DocumentData>> {
    const teamQuery = query(collection(this.firestore, 'team'), where('name', '==', name));
    const snapshot = await getDocs(teamQuery);
    const ref = snapshot.docs[0]?.ref as DocumentReference<DocumentData> | undefined;
    if (!ref) {
      throw new Error(`Team not found for name: ${name}`);
    }
    return ref;
  }

  async deleteTeam(target: Team) {
      await deleteDoc(doc(this.firestore, 'team', target.id.toString()));
  }

  // 指定したチームに所属しているユーザーがいるか？
  async checkExistTeamMember(target: Team): Promise<boolean> {
    const teamDocRef = doc(this.firestore, 'team', target.id.toString());
    const memberQuery = query(collection(this.firestore, 'users'), where('team', '==', teamDocRef));
    const teamMemberCount = (await getDocs(memberQuery)).size;

    console.log(`memberCount = ${teamMemberCount}`);

    return !(teamMemberCount == 0);
  }
}
